import { AnimationEvent, animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { Store } from '@ngrx/store';
import { EpcotConfigService, EpcotModule } from 'packages/sports/web/app/src/common/epcot-config.service';
import { Observable } from 'rxjs';

import { QuickBetActions } from '../../quick-bet-actions';
import { betPlacedResultSelector } from '../../quick-bet.selectors';
import { IQuickBetPlaceResultState } from '../../quick-bet.state';
import { QuickBetConfirmationCompactComponent } from './quick-bet-confirmation-compact.component';
import { QuickBetConfirmationDetailedComponent } from './quick-bet-confirmation-detailed.component';

@Component({
    selector: 'bs-quick-bet-confirmation-container',
    templateUrl: './quick-bet-confirmation-container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./quick-bet-confirmation-container.component.scss'],
    imports: [QuickBetConfirmationCompactComponent, CommonModule, QuickBetConfirmationDetailedComponent],
    animations: [
        trigger('shrinkOut', [state('hide', style({ height: 0 })), transition('show => hide', animate('.2s ease', style({ height: '0' })))]),
    ],
})
export class QuickBetConfirmationContainerComponent {
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    close = signal(false);

    quickBetResultState$: Observable<IQuickBetPlaceResultState> = this.store.select(betPlacedResultSelector);

    isEpcotEnabled = this.epcotConfigService.isEnabled(EpcotModule.Betslip);
    constructor(
        private epcotConfigService: EpcotConfigService,
        private store: Store,
    ) {}

    confirmationClosed() {
        this.close.set(true);
    }

    animationDone(event: AnimationEvent) {
        if (event.toState === 'hide') {
            this.store.dispatch(QuickBetActions.closeResultScreen());
        }
    }
}
